import React, { useEffect, useState, useRef } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../url';
import './Banners.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Banners() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const swiperRef = useRef(null);

    useEffect(() => {
        cargarBanners();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (swiperRef.current) {
                swiperRef.current?.update();
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current?.update();
        }
    }, [images]);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const bannerImages = (data.banner || []).map(banner => banner.imagen);
                setImages(bannerImages);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar banners:', error);
                setLoading(false);
            });
    };

    const handleImageError = (e, originalUrl) => {
        const target = e.target;
        if (!target.dataset.fallbackStep) {
            target.dataset.fallbackStep = '1';
            const filename = (originalUrl || '').split('/').pop();
            if (filename) {
                target.src = `${baseURL}/imagenes_banners/${filename}`;
                return;
            }
        }
        if (target.dataset.fallbackStep === '1') {
            target.dataset.fallbackStep = '2';
            const filename = (originalUrl || '').split('/').pop();
            if (filename) {
                target.src = `/imagenes_banners/${filename}`;
                return;
            }
        }
        target.style.display = 'none';
    };

    return (
        <div className='BannerContain'>
            {loading ? (
                <div className='loadingBanner'></div>
            ) : (
                <>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={0}
                        grabCursor={true}
                        autoHeight={true}
                        loop={images.length > 1}
                        autoplay={{ delay: 4500, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        id='swiper_container'
                    >
                        {images.map((image, index) => (
                            <SwiperSlide id='SwiperSlide-scroll' key={index}>
                                <img
                                    src={image}
                                    alt={`banner-${index}`}
                                    onLoad={() => {
                                        if (swiperRef.current) {
                                            swiperRef.current?.update();
                                        }
                                    }}
                                    onError={(e) => handleImageError(e, image)}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    {images.length > 1 && (
                        <>
                            <button
                                type="button"
                                className="bannerNavBtn bannerNavPrev"
                                onClick={() => swiperRef.current?.slidePrev()}
                                aria-label="Banner anterior"
                            >
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>
                            <button
                                type="button"
                                className="bannerNavBtn bannerNavNext"
                                onClick={() => swiperRef.current?.slideNext()}
                                aria-label="Siguiente banner"
                            >
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        </>
                    )}
                </>
            )}
        </div>
    );
}
